import { createFileRoute, useSearch } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import { parseLocationSummaryFilters } from "lib/components/builders/communities/summary/locationSummaryTypes";
import LocationSummaryView from "lib/components/builders/communities/summary/LocationSummaryView";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../../../components/withAuthentication";

function LocationSummaryPage() {
  const { builderId, locationId } = useAppRouterParams();
  const search = useSearch({ strict: false });

  if (!builderId || !locationId) {
    return null;
  }

  return (
    <CommunityLayout currentPage="summary">
      <LocationSummaryView
        scope={{
          kind: "location",
          builderId,
          locationId,
          filters: parseLocationSummaryFilters(search),
        }}
      />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/summary/")({
  component: withAuthentication(LocationSummaryPage, {
    permissions: ["VIEW_LOCATION_SUMMARY"],
    features: ["locationSummary"],
  }),
});
